"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blockRenderPerf = exports.blockEmitPerf = exports.BlockType = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _variables = require("@blockwell/variables");
var _reactivity = require("@vue/reactivity");
var _eventer = require("@blockwell/eventer");
var _justPerformance = require("just-performance");
const blockRenderPerf = exports.blockRenderPerf = {};
const blockEmitPerf = exports.blockEmitPerf = {};
class BlockType {
  constructor() {
    (0, _defineProperty2.default)(this, "param", void 0);
    (0, _defineProperty2.default)(this, "blockVariables", []);
    (0, _defineProperty2.default)(this, "interactions", void 0);
    (0, _defineProperty2.default)(this, "effect", void 0);
    (0, _defineProperty2.default)(this, "events", new _eventer.Eventer());
  }
  /**
   * Variables defined by the block itself.
   *
   * If a variable has no name, it won't be exposed to other blocks.
   */
  variables() {
    return this.blockVariables;
  }

  /**
   * Load the necessary data to render this block.
   *
   * This must reference variables held by the block, as it is used to create the initial
   * reactivity for all variables it depends on.
   * @protected
   */

  /**
   * Add a block variable and track it for updating parameters.
   *
   * All the variable's parameters should get copied from block parameters because that information
   * gets used for updating blocks when they're being edited in the admin UI.
   *
   * @param type Variable type instance.
   * @param params Block parameters to copy variable parameters from.
   * @param keys List of keys to copy. A [string, string] entry will map the parameter key to something else.
   * @param name Variable name.
   */
  addBlockVariable(type, params, keys, name) {
    let useName = undefined;
    let nameKey = undefined;
    let context = undefined;
    if (name) {
      if (this.blockVariables.find(it => it.name === name)) {
        throw new Error(`Block already has a variable with the name ${name}`);
      }
      if (typeof name === "string") {
        useName = name;
      } else {
        let config = params[name.key];
        nameKey = name.key;
        if ((0, _variables.isVariableConfig)(config) && config.name) {
          useName = config.name;
          context = config.ctx;
        } else {
          useName = name.default;
        }
      }
    }
    let varParam;
    if (params) {
      if (keys) {
        varParam = (0, _reactivity.reactive)({});
        for (let it of keys) {
          if (Array.isArray(it)) {
            //@ts-ignore
            varParam[it[1]] = (0, _reactivity.toRef)(params, it[0]);
          } else {
            //@ts-ignore
            varParam[it] = (0, _reactivity.toRef)(params, it);
          }
        }
      } else {
        varParam = params;
      }
    }
    let ref = new _variables.VariableReference(type, varParam, true);
    this.blockVariables.push({
      name: useName,
      context,
      ref,
      keys: keys,
      nameKey
    });
    return ref;
  }
  addBlockVariablePair(type, params, keys, name) {
    let ref = this.addBlockVariable(type, params, keys, name);
    return {
      ref,
      type
    };
  }
  addBlockParameterVariable(key) {
    if (!this.param) {
      throw new Error("Cannot use addBlockParameterVariable before constructor has been called!");
    }
    return this.addBlockVariablePair(_variables.ParameterVariableInstance, this.param, [[key, "value"]]);
  }
  addWriteableVariable(name) {
    return this.addBlockVariablePair(new _variables.WriteableVariable("value"), null, null, name);
  }
  setInteractions(spec, variableTypes) {
    if (spec) {
      this.interactions = spec.map(it => {
        return new _variables.VariableReference(variableTypes.get("interaction"), it, true);
      });
      this.blockVariables = this.blockVariables.concat(this.interactions.map(it => {
        return {
          ref: it
        };
      }));
    }
  }
  renderType() {
    if (!this.effect) {
      this.effect = (0, _reactivity.effect)(() => {
        var _this$interactions;
        if (!blockRenderPerf[this.type]) {
          blockRenderPerf[this.type] = [];
        }
        if (!blockEmitPerf[this.type]) {
          blockEmitPerf[this.type] = [];
        }
        let start = _justPerformance.performance.now();
        let value = (0, _reactivity.toRaw)(this.renderValue());
        if (((_this$interactions = this.interactions) === null || _this$interactions === void 0 ? void 0 : _this$interactions.length) > 0) {
          value.interactions = this.interactions.map(it => {
            let val = it.value();
            return val === null || val === void 0 ? void 0 : val.value;
          });
        }
        blockRenderPerf[this.type].push(_justPerformance.performance.now() - start);
        start = _justPerformance.performance.now();
        this.events.emit("value", value);
        blockEmitPerf[this.type].push(_justPerformance.performance.now() - start);
      });
    } else {
      this.effect.effect.run();
    }
  }
}
exports.BlockType = BlockType;
//# sourceMappingURL=BlockType.js.map